var _g, _g2, _mask, _g3, _path, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHrmIsActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_6730_34098)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5922 9.36641C10.5922 11.2752 9.04479 12.8227 7.13595 12.8227C5.22711 12.8227 3.6797 11.2752 3.6797 9.36641C3.6797 7.45757 5.22711 5.91016 7.13595 5.91016C9.04479 5.91016 10.5922 7.45757 10.5922 9.36641ZM3.67961 14.5529H10.5921C12.5017 14.5529 14.0484 16.0996 14.0484 18.0092C14.0484 19.9188 12.5017 21.4654 10.5921 21.4654H3.67961C1.77003 21.4654 0.223358 19.9188 0.223358 18.0092C0.223358 16.0996 1.77003 14.5529 3.67961 14.5529Z",
    fill: "url(#paint0_linear_6730_34098)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_6730_34098)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3202 9.36641C22.3202 11.2752 20.7728 12.8227 18.864 12.8227C16.9551 12.8227 15.4077 11.2752 15.4077 9.36641C15.4077 7.45757 16.9551 5.91016 18.864 5.91016C20.7728 5.91016 22.3202 7.45757 22.3202 9.36641ZM15.4076 14.5529H22.3201C24.2297 14.5529 25.7764 16.0996 25.7764 18.0092C25.7764 19.9188 24.2297 21.4654 22.3201 21.4654H15.4076C13.4981 21.4654 11.9514 19.9188 11.9514 18.0092C11.9514 16.0996 13.4981 14.5529 15.4076 14.5529Z",
    fill: "url(#paint1_linear_6730_34098)"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_6730_34098",
    maskUnits: "userSpaceOnUse",
    x: 3.34598,
    y: 2.8125,
    width: 20,
    height: 21,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 3.34598,
    y: 2.8125,
    width: 20,
    height: 21
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3274 8.13956C17.3274 10.5293 15.3901 12.4666 13.0003 12.4666C10.6105 12.4666 8.67325 10.5293 8.67325 8.13956C8.67325 5.74979 10.6105 3.8125 13.0003 3.8125C15.3901 3.8125 17.3274 5.74979 17.3274 8.13956ZM8.67304 14.0405H17.3272C19.7179 14.0405 21.6542 15.9768 21.6542 18.3675C21.6542 20.7582 19.7179 22.6946 17.3272 22.6946H8.67304C6.28234 22.6946 4.34598 20.7582 4.34598 18.3675C4.34598 15.9768 6.28234 14.0405 8.67304 14.0405Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_6730_34098)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3274 8.13956C17.3274 10.5293 15.3901 12.4666 13.0003 12.4666C10.6105 12.4666 8.67325 10.5293 8.67325 8.13956C8.67325 5.74979 10.6105 3.8125 13.0003 3.8125C15.3901 3.8125 17.3274 5.74979 17.3274 8.13956ZM8.67304 14.0405H17.3272C19.7179 14.0405 21.6542 15.9768 21.6542 18.3675C21.6542 20.7582 19.7179 22.6946 17.3272 22.6946H8.67304C6.28234 22.6946 4.34598 20.7582 4.34598 18.3675C4.34598 15.9768 6.28234 14.0405 8.67304 14.0405Z",
    fill: "url(#paint2_linear_6730_34098)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0003 13.4666C15.9424 13.4666 18.3274 11.0816 18.3274 8.13956H16.3274C16.3274 9.97705 14.8378 11.4666 13.0003 11.4666V13.4666ZM7.67325 8.13956C7.67325 11.0816 10.0583 13.4666 13.0003 13.4666V11.4666C11.1628 11.4666 9.67325 9.97705 9.67325 8.13956H7.67325ZM13.0003 2.8125C10.0583 2.8125 7.67325 5.19751 7.67325 8.13956H9.67325C9.67325 6.30208 11.1628 4.8125 13.0003 4.8125V2.8125ZM18.3274 8.13956C18.3274 5.19751 15.9424 2.8125 13.0003 2.8125V4.8125C14.8378 4.8125 16.3274 6.30208 16.3274 8.13956H18.3274ZM17.3272 13.0405H8.67304V15.0405H17.3272V13.0405ZM22.6542 18.3675C22.6542 15.4245 20.2702 13.0405 17.3272 13.0405V15.0405C19.1656 15.0405 20.6542 16.5291 20.6542 18.3675H22.6542ZM17.3272 23.6946C20.2702 23.6946 22.6542 21.3105 22.6542 18.3675H20.6542C20.6542 20.2059 19.1656 21.6946 17.3272 21.6946V23.6946ZM8.67304 23.6946H17.3272V21.6946H8.67304V23.6946ZM3.34598 18.3675C3.34598 21.3105 5.73005 23.6946 8.67304 23.6946V21.6946C6.83462 21.6946 5.34598 20.2059 5.34598 18.3675H3.34598ZM8.67304 13.0405C5.73005 13.0405 3.34598 15.4245 3.34598 18.3675H5.34598C5.34598 16.5291 6.83462 15.0405 8.67304 15.0405V13.0405Z",
    fill: "#FFF2E5",
    mask: "url(#path-3-outside-1_6730_34098)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_6730_34098)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3274 8.13956C17.3274 10.5293 15.3901 12.4666 13.0003 12.4666C10.6105 12.4666 8.67325 10.5293 8.67325 8.13956C8.67325 5.74979 10.6105 3.8125 13.0003 3.8125C15.3901 3.8125 17.3274 5.74979 17.3274 8.13956ZM8.67304 14.0405H17.3272C19.7179 14.0405 21.6542 15.9768 21.6542 18.3675C21.6542 20.7582 19.7179 22.6946 17.3272 22.6946H8.67304C6.28234 22.6946 4.34598 20.7582 4.34598 18.3675C4.34598 15.9768 6.28234 14.0405 8.67304 14.0405Z",
    fill: "url(#paint3_linear_6730_34098)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_6730_34098",
    x: 0.223358,
    y: 5.91016,
    width: 13.825,
    height: 15.5547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6730_34098"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_6730_34098",
    x: 11.9514,
    y: 5.91016,
    width: 13.825,
    height: 15.5547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6730_34098"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_6730_34098",
    x: 3.34598,
    y: 2.8125,
    width: 19.3083,
    height: 20.8828,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6730_34098"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_6730_34098",
    x: 4.34598,
    y: 3.8125,
    width: 17.3083,
    height: 18.8828,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6730_34098"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6730_34098",
    x1: 7.13587,
    y1: 5.91016,
    x2: 7.13587,
    y2: 21.4654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA36F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6730_34098",
    x1: 18.8639,
    y1: 5.91016,
    x2: 18.8639,
    y2: 21.4654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA36F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6730_34098",
    x1: 13.0001,
    y1: 3.8125,
    x2: 13.0001,
    y2: 22.6946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5CBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4ABB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6730_34098",
    x1: 19.5605,
    y1: 3.8125,
    x2: 2.83907,
    y2: 21.2495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA15E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6636"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrmIsActive);
export default __webpack_public_path__ + "static/media/hrmIsActive.10a87bcb1f2c6459aa99e95c73e115ef.svg";
export { ForwardRef as ReactComponent };